/* global axios */
/* eslint-disable no-console -- Deliberate, temporary console instrumentation with restoration. */
// Capture error types and timing, never arbitrary console arguments or messages.
export function startDiagnosticCapture(accountId, token) {
  const events = [];
  const started = performance.now();
  const add = (level, error) => {
    if (events.length >= 200) return;
    events.push({
      level,
      error: error instanceof Error ? error.name : 'Error',
      elapsed_ms: Math.round(performance.now() - started),
    });
  };
  const originals = {};
  const wrappers = {};
  ['error', 'warn'].forEach(level => {
    originals[level] = console[level];
    wrappers[level] = (...args) => {
      add(
        level,
        args.find(arg => arg instanceof Error)
      );
      originals[level].apply(console, args);
    };
    console[level] = wrappers[level];
  });
  const onError = event => add('error', event.error);
  const onRejection = event => add('rejection', event.reason);
  window.addEventListener('error', onError);
  window.addEventListener('unhandledrejection', onRejection);
  const interceptor = axios.interceptors.request.use(config => {
    const target = new URL(axios.getUri(config), window.location.origin);
    if (
      target.origin === window.location.origin &&
      target.pathname.startsWith(`/api/v1/accounts/${accountId}/`)
    ) {
      config.headers['X-Bug-Report-Diagnostic'] = token;
    }
    return config;
  });
  return () => {
    axios.interceptors.request.eject(interceptor);
    window.removeEventListener('error', onError);
    window.removeEventListener('unhandledrejection', onRejection);
    Object.keys(originals).forEach(level => {
      if (console[level] === wrappers[level]) console[level] = originals[level];
    });
    return events;
  };
}
